var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoItemAvailable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237.443,
    height: 250.579,
    viewBox: "0 0 237.443 250.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40268",
    "data-name": "Group 40268",
    transform: "translate(-1592.272 -564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-box",
    transform: "translate(1592.272 564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M215.776,243.061,250.837,208H185.514L162.86,230.653l5.2,5.2,20.5-20.5h44.519l-24.029,24.028H110.1L78.717,208H13.394l35.061,35.061L13.394,278.123h112.4l26.182-26.183v97.286H57.334V286.214H49.979v70.368H214.252V278.123h36.585ZM75.671,215.356,99.7,239.384H55.18L31.151,215.356Zm47.076,55.412h-91.6l24.028-24.028h91.595Zm84.15,78.459H159.331V246.739H206.9Zm7.356-97.286,18.827,18.827H214.253Z",
    transform: "translate(-13.394 -106.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M177.632,124.86l29.5-12.23A42.9,42.9,0,1,0,189.862,95.36ZM197.1,93.205a35.547,35.547,0,1,1,12.186,12.186l-1.59-.957-16.464,6.825L198.059,94.8Z",
    transform: "translate(-97.095 -16.308)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M147.524,23.047A11.524,11.524,0,1,0,136,11.524,11.537,11.537,0,0,0,147.524,23.047Zm0-15.692a4.168,4.168,0,1,1-4.168,4.168A4.173,4.173,0,0,1,147.524,7.356Z",
    transform: "translate(-75.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M408,131.524A11.524,11.524,0,1,0,419.524,120,11.537,11.537,0,0,0,408,131.524Zm11.524-4.168a4.168,4.168,0,1,1-4.168,4.168A4.173,4.173,0,0,1,419.524,127.356Z",
    transform: "translate(-214.497 -61.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M159.5,456h7.846v7.356H159.5Z",
    transform: "translate(-87.854 -232.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M191.5,456h7.846v7.356H191.5Z",
    transform: "translate(-104.162 -232.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M223.5,456h7.846v7.356H223.5Z",
    transform: "translate(-120.47 -232.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M335.4,424.465l5.49-5.491v18.582h7.355V418.974l5.49,5.491,5.2-5.2-14.37-14.369L330.2,419.263Z",
    transform: "translate(-174.846 -206.346)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g739",
    transform: "translate(1704.567 604.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path741",
    d: "M-70.145-34.1a7.724,7.724,0,0,1-5.5-2.277l-5.074-5.074-5.074,5.074a7.725,7.725,0,0,1-5.5,2.277,7.724,7.724,0,0,1-5.5-2.277,7.784,7.784,0,0,1,0-11l5.074-5.075-5.074-5.075a7.784,7.784,0,0,1,0-11,7.724,7.724,0,0,1,5.5-2.277,7.725,7.725,0,0,1,5.5,2.277l5.074,5.075,5.074-5.074a7.723,7.723,0,0,1,5.5-2.277,7.725,7.725,0,0,1,5.5,2.277,7.784,7.784,0,0,1,0,11l-5.075,5.075,5.075,5.075a7.784,7.784,0,0,1,0,11A7.726,7.726,0,0,1-70.145-34.1ZM-80.717-47.706a2.592,2.592,0,0,1,1.833.759l6.907,6.907a2.574,2.574,0,0,0,1.832.759,2.576,2.576,0,0,0,1.833-.759,2.6,2.6,0,0,0,0-3.665l-6.907-6.907a2.592,2.592,0,0,1-.759-1.833,2.592,2.592,0,0,1,.759-1.833l6.907-6.907a2.6,2.6,0,0,0,0-3.665,2.575,2.575,0,0,0-1.833-.759,2.574,2.574,0,0,0-1.832.759l-6.907,6.907a2.576,2.576,0,0,1-1.833.759,2.592,2.592,0,0,1-1.833-.759l-6.907-6.907a2.575,2.575,0,0,0-1.833-.759,2.574,2.574,0,0,0-1.832.759,2.6,2.6,0,0,0,0,3.665l6.907,6.907a2.592,2.592,0,0,1,0,3.665l-6.907,6.907a2.6,2.6,0,0,0,0,3.665,2.574,2.574,0,0,0,1.832.759,2.575,2.575,0,0,0,1.833-.759l6.907-6.907A2.592,2.592,0,0,1-80.717-47.706Z",
    transform: "translate(99.061 70.792)",
    fill: "#06f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_66",
    "data-name": "Union 66",
    d: "M-4625.421,11386.945l-2.051-2.052-2.053,2.052a3.784,3.784,0,0,1-2.681,1.112,3.785,3.785,0,0,1-2.684-1.112,3.8,3.8,0,0,1,0-5.364l2.052-2.052-2.052-2.053a3.8,3.8,0,0,1,0-5.364,3.789,3.789,0,0,1,5.364,0l2.053,2.052,2.051-2.052a3.8,3.8,0,0,1,5.368,0,3.8,3.8,0,0,1,0,5.364l-2.053,2.053,2.053,2.052a3.8,3.8,0,0,1,0,5.364,3.79,3.79,0,0,1-2.684,1.112A3.792,3.792,0,0,1-4625.421,11386.945Z",
    transform: "translate(6269.267 -10755.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_67",
    "data-name": "Union 67",
    d: "M-4625.421,11386.945l-2.051-2.052-2.053,2.052a3.784,3.784,0,0,1-2.681,1.112,3.785,3.785,0,0,1-2.684-1.112,3.8,3.8,0,0,1,0-5.364l2.052-2.052-2.052-2.053a3.8,3.8,0,0,1,0-5.364,3.789,3.789,0,0,1,5.364,0l2.053,2.052,2.051-2.052a3.8,3.8,0,0,1,5.368,0,3.8,3.8,0,0,1,0,5.364l-2.053,2.053,2.053,2.052a3.8,3.8,0,0,1,0,5.364,3.79,3.79,0,0,1-2.684,1.112A3.792,3.792,0,0,1-4625.421,11386.945Z",
    transform: "translate(6417.267 -10807)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItemAvailable);
export default __webpack_public_path__ + "static/media/no-item-available.88a6f6ca27502e168a3d0b9ae728f94b.svg";
export { ForwardRef as ReactComponent };